(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const sliderWrapper = document.querySelector('#product-slider');

  if (!sliderWrapper) return;

  const glide = sliderWrapper.querySelector('.glide');

  if (!glide) return;

  const slideCount = glide.querySelectorAll('.glide__slide').length;

  console.log('Slides:', slideCount);

  if (slideCount > 3) {
    new Glide(glide, {
      type: 'carousel',
      perView: 3,
      gap: 20,
      breakpoints: {
        1024: { perView: 2 },
        768: { perView: 1 },
      },
    }).mount();
  } else {
    const arrows = glide.querySelector('[data-glide-el="controls"]');
    if (arrows) {
      arrows.style.display = 'none';
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
